/**
 * Vanilla Zustand store for GPS fixes, created outside React so 1 Hz updates
 * don't re-render the tree. Instruments subscribe with narrow selectors; the
 * map subscribes imperatively in MapController (spec 02).
 */
import { createStore } from 'zustand/vanilla';

export interface Fix {
  lat: number;
  lon: number;
  accuracyM: number;
  sogKn: number | null;
  cogDeg: number | null;
  ts: number;
}

export type GpsStatus = 'idle' | 'acquiring' | 'ok' | 'stale' | 'lost' | 'denied' | 'unavailable';

export interface PosState {
  fix: Fix | null;
  status: GpsStatus;
  setFix: (fix: Fix) => void;
  setStatus: (status: GpsStatus) => void;
}

export const posStore = createStore<PosState>((set) => ({
  fix: null,
  status: 'idle',
  setFix: (fix) => set({ fix }),
  setStatus: (status) => set({ status }),
}));
